const groupProperties = {
  baseboard: ['type', 'height', 'typeObs', 'typeValueRange'],
  ceiling: ['finish', 'preFinish', 'finishObs'],
  floor: ['finish', 'finishObs', 'preFinish', 'preFinishObs', 'hasFloorFiller', 'floorFillerMaterial', 'floorFillerThickness'],
  guardrail: ['type', 'height', 'typeObs', 'typeExtra'],
  pool: ['exeternalFinish', 'poolHasHandrail', 'poolHasHandrailObs', 'structure', 'structureObs', 'upperFinish', 'upperFinishObs', 'upperFinishExtra'],
  stairs: ['finish', 'finishObs', 'handrail', 'handrailObs', 'structure', 'structureObs', 'preFinishObs', 'roofFinish', 'roofPreFinish', 'mirrorFinish', 'mirrorPreFinish'],
  walls: ['finish', 'finishObs', 'preFinish', 'preFinishObs', 'isPillarDiff', 'pillarFinish', 'pillarPreFinish', 'hidrWallFinish', 'hidrWallFinishObs']
}

const groups = ['baseboards', 'ceiling', 'floors', 'guardrail', 'pools', 'stairs', 'wallsRevest']

const translateProperty = {
  type: 'Tipo',
  height: 'Altura',
  typeObs: 'Observações',
  typeValueRange: 'Valores de referência',
  finish: 'Acabamento',
  preFinish: 'Pré-acabamento',
  finishObs: 'Observações',
  preFinishObs: 'Observações',
  typeExtra: 'Tipo extra',
  exeternalFinish: 'Acabamento externo',
  poolHasHandrail: 'Possui corrimão',
  poolHasHandrailObs: 'Observações',
  structure: 'Estrutura',
  structureObs: 'Observações',
  upperFinish: 'Acabamento superior',
  upperFinishObs: 'Observações',
  upperFinishExtra: 'Acabamento superior extra',
  handrail: 'Corrimão',
  handrailObs: 'Observações',
  roofFinish: 'Acabamento do teto',
  isPillarDiff: 'Pilar com acabamento diferente',
  pillarFinish: 'Acabamento do pilar',
  pillarPreFinish: 'Pré-acabamento do pilar',
  hidrWallFinish: 'Acabamento da parede hidráulica',
  hidrWallFinishObs: 'Observações'
}

const translateGroup = {
  baseboards: 'Rodapés',
  ceiling: 'Tetos',
  floors: 'Pisos',
  guardrail: 'Guarda-corpos',
  pools: 'Piscinas',
  stairs: 'Escadas',
  wallsRevest: 'Paredes'
}

const CompleteFormResume = ({ form, handleChangeView }) => {
  if (!form) return <></>

  const { clientInfos, roomDefinitions } = form

  const rooms = []

  const checkRoom = (arr, room) => {
    return roomDefinitions[arr].includes(room)
  }

  const checkOne = (i, dflt) => {
    switch (i) {
      case "baseboards":
        return 'baseboardGroups'
      case "floors":
        return 'floorGroups'
      case "pools":
        return 'poolGroups'
      case "wallsRevest":
        return 'wallGroups'
      default:
        return dflt
    }
  }

  const checkTwo = (i) => {
    switch (i) {
      case "baseboards":
        return 'baseboard'
      case "floors":
        return 'floor'
      case "pools":
        return 'pool'
      case "wallsRevest":
        return 'walls'
      default:
        return i
    }
  }

  form.rooms.sort().forEach(i => {
    let item = { room: i }
    groups.forEach(groupName => {
      if (checkRoom(groupName, i)) {
        const toGet = `${groupName}Groups`
        const filt = checkOne(groupName, toGet)
        const baseboardFilt = checkTwo(groupName)
        const temp = clientInfos[filt].find(j => j.rooms.includes(i))
        if (temp) {
          item[groupName] = {}
          groupProperties[baseboardFilt].forEach(j => {
            if (temp[j]) {
              item[groupName][j] = Array.isArray(temp[j]) ? temp[j].map(k => k.type).join(', ') : temp[j]
            }
          });
        };
      }
    });
    rooms.push(item)
  })

  // form.rooms.map(i => {
  //   let item = { room: i }
  //   if (checkRoom('baseboards', i)) {
  //     const baseboard = clientInfos.baseboardGroups.find(j => j.rooms.includes(i))
  //     if (baseboard) {
  //       item.baseboard = {};
  //       groupProperties.baseboard.map(j => {
  //         console.log(baseboard[j])
  //         if (baseboard[j]) item.baseboard[j] = baseboard[j]
  //       })
  //     }
  //   }
  //   if (checkRoom('ceiling', i)) {
  //     const ceiling = clientInfos.ceilingGroups.find(j => j.rooms.includes(i))
  //     if (ceiling) {
  //       item.ceiling = {};
  //       groupProperties.ceiling.map(j => {
  //         console.log(ceiling[j])
  //         if (ceiling[j]) item.ceiling[j] = ceiling[j]
  //       })
  //     }
  //   }
  //   rooms.push(item)
  // })


  return (
    <div className="complete-form-resume">
      <h1>Dados Gerais</h1>
      <p className='change-view' onClick={handleChangeView}>Visualizar informações já respondidas</p>
      <h2>Informações</h2>
      <p>Obra: {form?.name}</p>
      <p>Id: {form?._id}</p>
      <p>Data de criação: {form.created_at}</p>
      <p>Última data de edição: {form.updated_at}</p>
      <p>Responsável pelo preenchimento: {clientInfos.user?.name} - {clientInfos.user?.email}</p>

      <h2>Telhado:</h2>
      <p>Estrutura: {clientInfos.roofStructure}</p>
      <p>Material: {clientInfos.roofType} {clientInfos.roofTypeExtra && `- ${clientInfos.roofTypeExtra}`}</p>
      {clientInfos.roofTypeObs && <p>Observações: {clientInfos.roofTypeObs}</p>}
      <p>Calha: {clientInfos.roofGutter}</p>

      <h2>Soleiras:</h2>
      <p>Locais: {clientInfos.thresholdLocs.join(', ')}</p>
      <p>Material: {clientInfos.thresholdMats} {clientInfos.thresholdMatsExtra && `- ${clientInfos.thresholdMatsExtra}`}</p>
      {clientInfos.thresholdMatsObs && <p>Observações: {clientInfos.thresholdMatsObs}</p>}

      <h2>Rufos</h2>
      <p>Locais: {clientInfos.flashing.join(', ')}</p>
      <p>Material: {clientInfos.flashingMats}</p>
      {clientInfos.flashingMatsObs && <p>Observações: {clientInfos.flashingMatsObs}</p>}

      <h2>Peitoris</h2>
      <p>Material: {clientInfos.sill}</p>
      {clientInfos.extraSill && <p>Observações: {clientInfos.extraSill}</p>}

      <h2>Molduras</h2>
      <p>Tipo: {clientInfos.frameType}</p>
      {clientInfos.frameTypeObs && <p>Observações: {clientInfos.frameTypeObs}</p>}

      <h2>Vagas</h2>
      <p>Tipo de demarcação: {clientInfos.parking}</p>
      <p>Material: {clientInfos.parkingMats}</p>
      {clientInfos.parkingObs && <p>Observações: {clientInfos.parkingObs}</p>}

      <h1>Dados por ambiente</h1>

      {rooms.map(i => {
        return <div key={i.room}>
          <h2 className="margin-top-16">{i.room}</h2>
          {Object.keys(i).map(j => {
            if (j !== 'room') {
              return <div key={j} className="margin-left-16">
                <p>{translateGroup[j]}</p>
                <div className="margin-left-16">
                  {Object.keys(i[j]).map(k => {
                    let val = i[j][k];
                    if (val.type !== "" && Array.isArray(val)) val === val.map(i => i.type).join(', ')
                    const ret = Array.isArray(val) ? val.join(', ') : val;
                    if (ret === "") return null
                    return <p>{`${translateProperty[k]}: ${ret}`}</p>
                  })}
                </div>
              </div>
            }
          })}
        </div>
      })}
    </div>
  );
}

export default CompleteFormResume;